import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { PayrollSetupList } from './PayrollSetupList'
import {
  GEP_ENROLL_PATHS,
  ONBOARDING_STEPS,
  useUpdatePayrollOnboardingStep,
} from '../helpers'
import { fetchPayrollProfileIfNeeded } from '../payrollActions'
import { Button, Card, Separator, Text } from '@/ui'
import { useAppDispatch } from '@/utils/typeHelpers'
import { TypographyStyles } from '@/styles'

export const PayrollEnrollComplete = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  useUpdatePayrollOnboardingStep(ONBOARDING_STEPS.complete)

  useEffect(() => {
    dispatch(fetchPayrollProfileIfNeeded(true))
  }, [dispatch])

  return (
    <div>
      <Card>
        <Text variant={TypographyStyles.DISPLAY_XS}>Setting Up Payroll</Text>
        <Separator />

        <div className="flex flex-col lg:flex-row gap-6">
          <div className="w-full lg:w-2/3">
            <div className="flex flex-col gap-6 mt-4">
              <Text variant={TypographyStyles.H1}>
                You&apos;ve completed your Payroll Setup!
              </Text>
              <Text>
                We are sharing your company details with your state for
                approval, and you&apos;ll be notified via email once you have
                been approved to run payroll. This usually takes 1–2 business
                days. You can also track your approval status on the Heard
                dashboard.
              </Text>
              <Text>We&apos;ll be in touch shortly!</Text>
              <Text>The Heard Team</Text>
              <div className="w-full lg:w-2/3">
                <Button onClick={() => navigate(GEP_ENROLL_PATHS.intro)}>
                  Back to payroll home
                </Button>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/3">
            <PayrollSetupList />
          </div>
        </div>
      </Card>
    </div>
  )
}
